import { render, staticRenderFns } from "./DashboardMainContent.vue?vue&type=template&id=688e1253&scoped=true&"
import script from "./DashboardMainContent.vue?vue&type=script&lang=js&"
export * from "./DashboardMainContent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMainContent.vue?vue&type=style&index=0&id=688e1253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e1253",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
